import { every, includes, isArray, isEmpty, some } from 'lodash';

import { ProvisioningEnum, RolloutEnum } from '@lib/resources/types';

import { Permissions } from 'selectors/selectPermissions';

export function hasAccessToProduct(
  // WORKAROUND keeping permissions? for safety
  permissions?: Permissions,
  value?: ProvisioningEnum | RolloutEnum | (ProvisioningEnum | RolloutEnum)[],
  arrayMode: 'some' | 'every' = 'some',
): boolean {
  // Use recursivity for arrays
  if (isArray(value)) {
    if (isEmpty(value)) return true;
    const fn = arrayMode === 'some' ? some : every;
    return fn(value, (k) => hasAccessToProduct(permissions, k as ProvisioningEnum | RolloutEnum));
  }
  if (!value) return true;

  if (!permissions) return false;

  return includes(permissions.allProducts, value);
}
